export const REQUEST_STATE_CHOICES = [
  { id: null, name: '\xa0' },
  { id: 'pending', name: 'Non processata' },
  { id: 'processedButNotNotified', name: 'Processata ma non notificata' },
  { id: 'notified', name: 'Notificata' },
  { id: 'reportSent', name: 'Report inviato' },
];
